import { useState } from 'react';
import { Lightbulb } from 'lucide-react';
import { cn } from '../lib/utils';

export default function ProductImage({ src, alt = '', className }) {
  const [failed, setFailed] = useState(false);
  return (
    <div className={cn('shrink-0 overflow-hidden rounded-lg bg-sunken', className)}>
      {src && !failed ? (
        <img src={src} alt={alt} loading="lazy" decoding="async" onError={() => setFailed(true)} className="h-full w-full object-cover" />
      ) : (
        <div className="flex h-full w-full items-center justify-center text-ink2/50">
          <Lightbulb className="h-5 w-5" />
        </div>
      )}
    </div>
  );
}
